"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ContentLine_1 = require("../../contentLine/ContentLine");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var useFinanceSummary_1 = require("../../../../common/hooks/useFinanceSummary");
var FinanceRowValue_1 = require("./FinanceRowValue");
var financeSummaryBreakdownWidgetStyles_1 = require("./financeSummaryBreakdownWidgetStyles");
var clsx_1 = require("clsx");
var FinanceDisclaimer_1 = require("./FinanceDisclaimer");
var globalTypes_1 = require("../../../../../../__generated__/globalTypes");
var FinanceSummaryBreakdownWidget = function (_a) {
    var finance = _a.finance;
    var _b;
    var disclaimers = finance.disclaimers;
    var styles = financeSummaryBreakdownWidgetStyles_1.default();
    var financeBreakdown = useFinanceSummary_1.default(finance);
    var isCash = ((_b = finance) === null || _b === void 0 ? void 0 : _b.type) === globalTypes_1.FinanceFormType.cash;
    return (<core_1.Container className={styles.wrapper}>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={styles.title}>
            <Translation_1.default className={styles.titleContent} id={"trans__fincalc__breakdown__" + (isCash ? 'cash_breakdown' : 'finance_breakdown') + "_title"}/>
          </core_1.Typography>} dataTest={"calculator:" + (isCash ? 'cashBreakdown' : 'financeBreakdownBlock')}/>
      <core_1.Box className={styles.breakdown}>
        {financeBreakdown.map(function (row) {
        var _a, _b;
        return (<>
            {row.shouldDisplayDivider && <core_1.Divider />}
            <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
                  <Translation_1.default className={clsx_1.default([styles.elementContent, (_a = {}, _a[styles.highlighted] = row.highlighted, _a)])} id={row.title}/>
                </core_1.Typography>} secondaryContent={<FinanceRowValue_1.default row={row}/>} dataTest={'summary:financeBreakdownBlock:label'} key={row.title} className={clsx_1.default([styles.breakdownRow, (_b = {}, _b[styles.highlightedRow] = row.highlighted, _b)])}/>
          </>);
    })}
      </core_1.Box>
      {disclaimers && <FinanceDisclaimer_1.default disclaimers={disclaimers}/>}
    </core_1.Container>);
};
exports.default = FinanceSummaryBreakdownWidget;
